/**
 * editOpportunityConstants.js - the picklists and inline styles for the
 * opportunity editor. Hoisted to module scope on purpose: defining these
 * inside the modal remounted its inputs on every keystroke.
 */

export const BTN_PRIMARY = {
  background: '#1B5E20',
  color: '#fff',
  border: 'none',
  padding: '9px 20px',
  borderRadius: 6,
  fontWeight: 700,
  fontSize: 11,
  cursor: 'pointer',
  fontFamily: 'Montserrat',
};
export const BTN_CANCEL = {
  background: '#fff',
  color: '#555',
  border: '1px solid #E0E0E0',
  padding: '9px 20px',
  borderRadius: 6,
  fontWeight: 600,
  fontSize: 11,
  cursor: 'pointer',
  fontFamily: 'Montserrat',
};
// Paul Q5: Lost = lost to someone, Cancelled = not awarded / cancelled, No
// Quote = we backed out. Closed = Lost + Cancelled + No Quote. Cancelled was
// "Dead" from 9/29 to 10/1/26 (Q-01: Dead means "shut down" for a site, so the
// opportunity word went back to Cancelled; the server renamed the rows).
// There is no Budget status (removed 9/29/26, Paul Appendix A #7): a budgetary
// bid is Open, and Quote Type = Budgetary says what kind of quote it is.
// Complete is a won job that has finished (a project, like Won -
// data/projectStatus): the editor edits projects too since 10/8/26.
export const STATUS_LIST = ['Open', 'Won', 'Complete', 'Lost', 'Cancelled', 'No Quote'];
/** Not won = say why (11/3/26): moving to one of these needs a note (server: saveGuards.js closeReasonRefusal). */
export const NEEDS_REASON = ['Lost', 'Cancelled', 'No Quote'];
/** Won, whatever its case - the status that asks for the PO (Q-02). */
export const isWonStatus = (s) =>
  String(s == null ? '' : s)
    .trim()
    .toLowerCase() === 'won';

/* ===== Edit Opportunity Modal — GAT-styled, Dynamics-structured =====
 *
 * Same field structure as Microsoft Dynamics CRM (Name, Sales Process,
 * Summary + Quote tabs, computed fields locked) but rendered using the
 * GAT website's green/cream design language so it flows with the rest
 * of the site. All fields stay nullable — blank entries render as "-".
 */
export const SALES_STAGES = ['Qualify', 'Develop', 'Propose', 'Close'];
export const GAT_ACCENT = '#1B5E20';

export const rowSt = { display: 'flex', alignItems: 'baseline', padding: '5px 0', borderBottom: '1px solid #F2F4EE', gap: 12 };
export const labelSt = { fontSize: 11.5, color: '#555', fontWeight: 600, flexShrink: 0, width: 150 };
export const requiredSt = { color: '#B71C1C', marginLeft: 3, fontWeight: 800 };
export const inputSt = {
  flex: 1,
  padding: '6px 10px',
  borderRadius: 6,
  border: '1px solid #D8DED4',
  background: '#fff',
  fontSize: 12.5,
  fontFamily: "'Montserrat', sans-serif",
  color: '#0D0D0D',
  fontWeight: 600,
  outline: 'none',
  boxSizing: 'border-box',
  transition: 'border-color 0.15s',
};
export const computedSt = {
  ...inputSt,
  background: '#F1F8E9',
  color: '#1B5E20',
  cursor: 'not-allowed',
  border: '1px dashed #C8E6C9',
  fontFamily: "'JetBrains Mono', Consolas, monospace",
};

/* Pure derivations: margin / go-get / anticipated-value math. Kept out of the
   component so the formulas are testable and the render body stays small. */
